"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RouteSelectorLocation = void 0;
const class_transformer_1 = require("class-transformer");
const type_graphql_1 = require("type-graphql");
const LocationPosition_1 = require("../models/LocationPosition");
let RouteSelectorLocation = class RouteSelectorLocation {
    _id;
    name;
    image;
    machineName;
    countryName;
    localNames;
    otherNames;
    airportCodes;
    timezone = "";
    isDestination;
    ordersCount;
    position;
};
exports.RouteSelectorLocation = RouteSelectorLocation;
__decorate([
    (0, type_graphql_1.Field)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], RouteSelectorLocation.prototype, "_id", void 0);
__decorate([
    (0, type_graphql_1.Field)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], RouteSelectorLocation.prototype, "name", void 0);
__decorate([
    (0, type_graphql_1.Field)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], RouteSelectorLocation.prototype, "image", void 0);
__decorate([
    (0, type_graphql_1.Field)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], RouteSelectorLocation.prototype, "machineName", void 0);
__decorate([
    (0, type_graphql_1.Field)({ nullable: true }),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], RouteSelectorLocation.prototype, "countryName", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Array)
], RouteSelectorLocation.prototype, "localNames", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Array)
], RouteSelectorLocation.prototype, "otherNames", void 0);
__decorate([
    (0, type_graphql_1.Field)(() => [String], { nullable: true }),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Array)
], RouteSelectorLocation.prototype, "airportCodes", void 0);
__decorate([
    (0, type_graphql_1.Field)(() => String),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], RouteSelectorLocation.prototype, "timezone", void 0);
__decorate([
    (0, type_graphql_1.Field)({ nullable: true }),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Boolean)
], RouteSelectorLocation.prototype, "isDestination", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Number)
], RouteSelectorLocation.prototype, "ordersCount", void 0);
__decorate([
    (0, type_graphql_1.Field)(() => LocationPosition_1.LocationPosition),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", LocationPosition_1.LocationPosition)
], RouteSelectorLocation.prototype, "position", void 0);
exports.RouteSelectorLocation = RouteSelectorLocation = __decorate([
    (0, type_graphql_1.InputType)("RouteSelectorLocationInput"),
    (0, type_graphql_1.ObjectType)("RouteSelectorLocation")
], RouteSelectorLocation);
//# sourceMappingURL=RouteSelectorLocation.js.map